import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Accordions/AccordionModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertsMenuWrapper"] */ "/vercel/path0/src/components/AlertsMenu/AlertsMenuWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Chatbot/Chatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/HungerAlert/HungerAlertLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Legend/MapLegendLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Map/MapLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/src/components/Sidebar/Sidebar.tsx");
